import { Button, useMediaQuery } from "@mui/material";
import { useState } from "react";
import GetInTouchModal from "../components/GetInTouchModal";
import forvendors from "../assets/images/forvendors.jpg";

function ForVendors() {
  const isMobile = useMediaQuery("(max-width: 720px)");

  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      {modalIsOpen && (
        <GetInTouchModal handleClose={() => setModalIsOpen(false)} />
      )}
      <div className="for-vendors">
        <h1>FOR VENDORS</h1>

        <p >
          Join our growing network of Tamil wedding professionals. Whether
          you’re a caterer, photographer, decorator, or artisan, we connect you
          with clients who value your craft. <br />
          <br />
          Grow your reach. Share your passion.
        </p>

        <Button
          sx={{
            width: isMobile ? "70%" : "250px",
            marginBottom: "70px",
            letterSpacing: "2px", // Added letter spacing
          }}
          className="join-button"
          variant="outlined"
          onClick={() => setModalIsOpen(true)}
        >
          Join us now
        </Button>
        <img
          src={forvendors}
          width={"100%"}
          alt=""
          style={{
            height: isMobile ? "150px" : "350px",
            objectFit: "cover",
          }}
        />
      </div>
    </>
  );
}

export default ForVendors;
